export default __webpack_public_path__ + "static/media/image35.c4f94a83.png";